


































import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { db, firestore } from "@/scripts/firebase";
import RichTextEditor from "@/components/shared/RichTextEditor.vue";
import { collectionName } from "../../services/collection-name";
import { JinroRoomDocument } from "../../services/datatypes";

@Component({
  components: {
    RichTextEditor,
  },
})
export default class Billboad extends Vue {
  @Prop() readonly jinroRoom!: JinroRoomDocument;

  isChanged = false;
  editor: any | null = null;
  isEdit = false;

  get content(): object {
    if (this.jinroRoom) {
      return this.jinroRoom.billboardContent;
    }
    return {};
  }

  get isOwner() {
    if (!this.jinroRoom) {
      return false;
    }
    return (
      this.$store.state.firebaseUser &&
      this.jinroRoom.owner === this.$store.state.firebaseUser.uid
    );
  }

  handleEdit() {
    this.isEdit = true;
  }

  handleCancel() {
    console.log(this.editor);
    this.isEdit = false;
  }

  handleUpdate(editor: object) {
    this.isChanged = true;
    this.editor = editor;
  }
  async handleSave() {
    let content = {};
    if (this.editor) {
      content = this.editor.getJSON();
    }
    await this.refJinroRoom.set(
      {
        billboardContent: content,
        timeUpdated: firestore.FieldValue.serverTimestamp(),
      },
      { merge: true }
    );
    this.isEdit = false;
    this.isChanged = false;
  }

  get refJinroRoom(): firebase.firestore.DocumentReference {
    return db.doc(
      `${collectionName.jinrorooms}/${this.$route.params.jinroRoomId}`
    );
  }
}
